import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconCloseLargeComponent } from './icons/icon-close-large/icon-close-large.component';
import { IconCloseSmallComponent } from './icons/icon-close-small/icon-close-small.component';
import { IconFiltersShowComponent } from './icons/icon-filters-show/icon-filters-show.component';
import { IconMobileModeListComponent } from './icons/icon-mobile-mode-list/icon-mobile-mode-list.component';
import { IconMobileModeMapComponent } from './icons/icon-mobile-mode-map/icon-mobile-mode-map.component';
import { IconSidebarHideComponent } from './icons/icon-sidebar-hide/icon-sidebar-hide.component';
import { IconSidebarModeListComponent } from './icons/icon-sidebar-mode-list/icon-sidebar-mode-list.component';
import { IconSidebarModeTileComponent } from './icons/icon-sidebar-mode-tile/icon-sidebar-mode-tile.component';
import { IconSidebarShowComponent } from './icons/icon-sidebar-show/icon-sidebar-show.component';
import { IconWindowMaximizeComponent } from './icons/icon-window-maximize/icon-window-maximize.component';
import { IconWindowMinimizeComponent } from './icons/icon-window-minimize/icon-window-minimize.component';

type IconName
    = 'close-large'
    | 'close-small'
    | 'filters-show'
    | 'mobile-mode-list'
    | 'mobile-mode-map'
    | 'sidebar-hide'
    | 'sidebar-mode-list'
    | 'sidebar-mode-tile'
    | 'sidebar-show'
    | 'window-maximize'
    | 'window-minimize';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    imports: [
        IconCloseLargeComponent,
        IconCloseSmallComponent,
        IconFiltersShowComponent,
        IconMobileModeListComponent,
        IconMobileModeMapComponent,
        IconSidebarHideComponent,
        IconSidebarModeListComponent,
        IconSidebarModeTileComponent,
        IconSidebarShowComponent,
        IconWindowMaximizeComponent,
        IconWindowMinimizeComponent,
    ],
})
export class IconComponent {
    @Input({ required: true })
    public icon!: IconName;
}
